// import React, { useEffect, useReducer, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { Container, Box, TextField, Button, Typography, CircularProgress, FormGroup, FormControlLabel, Checkbox, Paper, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import dayjs from "dayjs";

// // Base URL for your backend API
// const path = `http://192.168.1.248:3109`;
// const pathh = `http://192.168.1.248:3107`;

// // Initial form state
// const initialState = {
//     CompanyName: "", ItemCode: "", ContactPerson: "", MobileNo: "", EmailId: "",
//     Website: "", Address1: "", PinCode: "", Area: "", City: "", State: "",
//     Country: "", ProductKey: "", WAKey: "", selectedOptions: [], normalDropdown: "CompanyName",
//     PaymentMode: "Bank", ChequeNoOrTransNo: "", Date: null, Amt: "", CD: "0",
//     CollectBy: "", RcdBy: "", MobileAppUsers: "",
//     isWhatsAppKeyEnabled: false, isMobileAppEnabled: false
// };

// // Reducer handles all form state modifications
// function reducer(state, action) {
//     switch (action.type) {
//         case "UPDATE_FIELD":
//             return { ...state, [action.field]: action.value };
//         case "TOGGLE_OPTION":
//             return { ...state, selectedOptions: state.selectedOptions.includes(action.option) ? state.selectedOptions.filter(o => o !== action.option) : [...state.selectedOptions, action.option] };
//         case "SET_OPTIONS":
//             return { ...state, selectedOptions: action.options };
//         case "RESET":
//             return { ...initialState, CollectBy: state.CollectBy || action.loggedInUser?.UserId || "", RcdBy: state.RcdBy || action.loggedInUser?.UserId || "" };
//         default:
//             return state;
//     }
// }

// export default function GenerateKey({ loggedInUser, companyData }) {
//     const { state: locationState } = useLocation();
//     const isNewMode = locationState?.mode !== "update";
//     const companyId = companyData?.[0]?.CompId;

//     const [form, dispatch] = useReducer(reducer, {
//         ...initialState,
//         CollectBy: loggedInUser?.UserId || "",
//         RcdBy: loggedInUser?.UserId || ""
//     });

//     const [gstInNumber, setGstInNumber] = useState("");
//     const [gstValid, setGstValid] = useState(null);
//     const [gstError, setGstError] = useState("");
//     const [gstLoading, setGstLoading] = useState(false);
//     const [checkboxOptions, setCheckboxOptions] = useState([]);
//     const [usersOptions, setUsersOptions] = useState([]);
//     const [keyError, setKeyError] = useState("");
//     const [customerId, setCustomerId] = useState("");
//     const [id, setId] = useState(null);
//     const [searchText, setSearchText] = useState("");
//     const [searchResults, setSearchResults] = useState([]);
//     const [showResults, setShowResults] = useState(false);
//     // New: Loading state for Generate/Update Key button
//     const [generateKeyLoading, setGenerateKeyLoading] = useState(false);
//     // New: Loading state for WhatsApp Key generation
//     const [whatsAppKeyLoading, setWhatsAppKeyLoading] = useState(false);

//     useEffect(() => {
//         axios.get(`${path}/api/features-list`).then(r => {
//             console.log(r.data);
//             setCheckboxOptions(r.data)
//         }).catch(console.error);
//         axios.get(`${pathh}/api/users`, { params: { companyId } }).then((res) => {
//             setUsersOptions(Array.isArray(res.data.data) ? res.data.data : []);
//         }).catch((error) => console.error("Error fetching users:", error));
//     }, [companyId]);

//     useEffect(() => {
//         if (locationState?.Id && !isNewMode) {
//             console.log("Received Id:", locationState.Id);
//             setId(locationState.Id);
//             axios.get(`${path}/api/members/get-data/${locationState.Id}`)
//                 .then((res) => {
//                     if (res.data.success) {
//                         const data = res.data.data;
//                         console.log('Fetched member data:', data);
//                         dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: data.CompanyName || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: data.ContactPerson || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ItemCode", value: data.ItemCode || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "MobileNo", value: data.MobileNo || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "EmailId", value: data.EmailId || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Website", value: data.Website || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Address1", value: data.Address1 || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Address2", value: data.Address2 || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Area", value: data.Area || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "City", value: data.City || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "State", value: data.State || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Country", value: data.Country || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: data.PinCode || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: data.ProductKey || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: data.WAKey || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: data.PaymentMode || "Bank" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: data.ChequeNoOrTransNo || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Date", value: data.PaymentDate ? dayjs(data.PaymentDate) : null });
//                         dispatch({ type: "UPDATE_FIELD", field: "Amt", value: data.Amount || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "CD", value: data.CD || "0" });
//                         dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: data.CollectById || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: data.RcdById || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: data.MobileAppUsers || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: data.isWhatsAppKeyEnabled });
//                         dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: data.isMobileAppEnabled });
//                         dispatch({ type: "SET_OPTIONS", options: data.SoftwareModule || [] });
//                         setCustomerId(data.CustomerID || "");
//                     } else {
//                         setKeyError(res.data.message || "Failed to fetch member data");
//                     }
//                 })
//                 .catch((error) => {
//                     console.error("Error fetching member data:", error);
//                     setKeyError("Error fetching member data");
//                 });
//         }
//     }, [locationState, isNewMode]);

//     useEffect(() => {
//         if (usersOptions.length > 0 && loggedInUser?.UserId) {
//             if (!form.CollectBy) {
//                 dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: loggedInUser.UserId });
//             }
//             if (!form.RcdBy) {
//                 dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: loggedInUser.UserId });
//             }
//         }
//     }, [usersOptions, loggedInUser, form.CollectBy, form.RcdBy]);

//     const handleGstBlur = async (e) => {
//         const gstin = e.target.value.trim().toUpperCase();
//         if (gstin.length !== 15 || /[^0-9A-Z]/.test(gstin)) {
//             setGstError("GSTIN must be exactly 15 alphanumeric characters");
//             setGstValid(false);
//             dispatch({ type: "RESET", loggedInUser });
//             return;
//         }

//         setGstError("");
//         setGstLoading(true);

//         try {
//             const resp = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gstin } });
//             if (!resp.data.success) {
//                 setGstError(`GST API status: ${resp.data.status}`);
//                 setGstValid(false);
//                 dispatch({ type: "RESET", loggedInUser });
//             } else {
//                 const d = resp.data.data;
//                 dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: d.CompanyName || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: d.ContactPerson || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Address1", value: d.Address1 || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Address2", value: d.Address2 || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Area", value: d.Area || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "City", value: d.City || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "State", value: d.State || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Country", value: d.Country || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: d.PinCode || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Website", value: d.Website || "" });
//                 setGstInNumber(gstin);
//                 setGstValid(true);
//             }
//         } catch (err) {
//             console.error("GST lookup failed:", err);
//             setGstError("Unable to fetch GST details");
//             setGstValid(false);
//             dispatch({ type: "RESET", loggedInUser });
//         } finally {
//             setGstLoading(false);
//         }
//     };

//     const handleGenerateWhatsAppKey = async () => {
//         setKeyError("");
//         // New: Set WhatsApp Key loading state to true
//         setWhatsAppKeyLoading(true);
//         try {
//             const { WAKey } = (await axios.post(`${path}/api/members/generate-whatsapp-key`, { selectedOptions: form.selectedOptions })).data;
//             console.log('Generated WAKey:', WAKey);
//             dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: WAKey });
//         } catch (err) {
//             console.error('Error generating WA key:', err);
//             setKeyError("Error generating WhatsApp Key.");
//         } finally {
//             // New: Set WhatsApp Key loading state to false
//             setWhatsAppKeyLoading(false);
//         }
//     };

//     const handleMobileAppToggle = (checked) => {
//         dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: checked });
//         const current = form.MobileAppUsers;
//         if (checked && (!current || !/^\d+$/.test(current) || parseInt(current, 10) < 1)) {
//             dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: "1" });
//             console.log('Mobile app enabled - defaulting MobileAppUsers to 1');
//         } else {
//             console.log(`Mobile app ${checked ? 'enabled' : 'disabled'}, MobileAppUsers: ${current}`);
//         }
//     };

//     const handleSubmit = async () => {
//         if (!form.CompanyName || !form.MobileNo || !form.selectedOptions.length) {
//             setKeyError("Company Name, Mobile No, and at least one feature are required.");
//             return;
//         }
//         try {
//             setKeyError("");
//             const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
//             const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;

//             const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

//             const payload = {
//                 ...form,
//                 PinCode: form.PinCode,
//                 selectedOptions: form.selectedOptions,
//                 CustomerID: customerId,
//                 ProductKey: form.ProductKey,
//                 WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
//                 MobileAppUsers: mobileUsers,
//                 isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
//                 isMobileAppEnabled: !!form.isMobileAppEnabled,
//                 DName: loggedInUser?.userName,
//                 PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
//                 CD: parseInt(form.CD, 10),
//                 CollectById: collectByUser?.UserId || null,
//                 CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
//                 RcdById: rcdByUser?.UserId || null,
//                 RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
//             };

//             console.log("submit payload", payload);
//             const resp = await axios.post(`${path}/api/members/insertClient`, payload);
//             if (resp.data.success) {
//                 alert("Client created successfully!");
//                 dispatch({ type: "RESET", loggedInUser });
//                 setCustomerId("");
//                 setId(null);
//                 setGstInNumber("");
//                 setGstValid(null);
//             } else {
//                 setKeyError("Server rejected creation: " + (resp.data.message || ""));
//             }
//         } catch (err) {
//             console.error("Create member error:", err);
//             setKeyError("Error creating member.");
//         }
//     };

//     const handleGenerateKey = async () => {
//         setKeyError("");
//         if (!form.selectedOptions.length) {
//             setKeyError("Select at least one feature.");
//             return;
//         }
//         // New: Set Generate Key loading state to true
//         setGenerateKeyLoading(true);
//         try {
//             console.log(form.selectedOptions);
//             const { ProductKey, customerId: cid } = (await axios.post(`${path}/api/members/generate-key`, { selectedOptions: form.selectedOptions })).data;
//             console.log('Generated ProductKey:', ProductKey, 'cid:', cid);
//             dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: ProductKey });
//             setCustomerId(cid);
//         } catch (err) {
//             console.error('Error generating product key:', err);
//             setKeyError("Error generating key.");
//         } finally {
//             // New: Set Generate Key loading state to false
//             setGenerateKeyLoading(false);
//         }
//     };

//     const handleUpdateKey = async () => {
//         if (!id) {
//             setKeyError("No record selected.");
//             return;
//         }
//         if (!form.ProductKey) {
//             setKeyError("Nothing to update—Product Key is empty.");
//             return;
//         }
//         // New: Set Generate Key loading state to true
//         setGenerateKeyLoading(true);
//         try {
//             setKeyError("");
//             const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
//             const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;
//             const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

//             const payload = {
//                 subscribedFeatures: form.selectedOptions,
//                 ProductKey: form.ProductKey,
//                 WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
//                 MobileAppUsers: mobileUsers,
//                 isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
//                 isMobileAppEnabled: !!form.isMobileAppEnabled,
//                 PaymentMode: form.PaymentMode,
//                 ChequeNoOrTransNo: form.ChequeNoOrTransNo,
//                 PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
//                 Amount: form.Amt ? parseFloat(form.Amt) : null,
//                 CD: parseInt(form.CD, 10),
//                 CollectById: collectByUser?.UserId || null,
//                 CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
//                 RcdById: rcdByUser?.UserId || null,
//                 RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
//             };
//             console.log("update payload", payload);
//             const resp = await axios.put(`${path}/api/members/update-key/${id}`, payload);
//             if (resp.data.success) {
//                 alert("Product Key updated!");
//             } else {
//                 setKeyError(resp.data.message || "Failed to update Product Key");
//             }
//         } catch (err) {
//             console.error("Error updating Product Key:", err);
//             setKeyError("Server error while updating Product Key.");
//         } finally {
//             // New: Set Generate Key loading state to false
//             setGenerateKeyLoading(false);
//         }
//     };

//     const handleClear = () => {
//         dispatch({ type: "RESET", loggedInUser });
//         setGstInNumber("");
//         setGstValid(null);
//         setGstError("");
//         setKeyError("");
//         setCustomerId("");
//         setId(null);
//         setSearchText("");
//         setSearchResults([]);
//         setShowResults(false);
//         console.log('Form cleared');
//     };

//     const compactInputStyle = { "& .MuiInputBase-root": { height: 40 }, "& .MuiInputLabel-root": { fontSize: "0.75rem" }, mt: 0.6 };

//     return (
//         <Container sx={{ maxWidth: "1300px !important", width: "100%" }}>
//             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                 <Box sx={{ mt: 1, mb: 1 }}>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                         <Typography variant="h5">{isNewMode ? "Generate New Key" : "Update Existing Key"}</Typography>
//                         <FormControlLabel control={<Checkbox checked={isNewMode} onChange={handleClear} />} label="New Mode?" />
//                     </Box>

//                     <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>
//                         <Box component="form" onSubmit={e => e.preventDefault()} sx={{ flex: 1 }}>
//                             {isNewMode && (
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//                                     <TextField size="small" fullWidth label="GST No" value={gstInNumber} onBlur={handleGstBlur} error={!!gstError} helperText={gstError} InputProps={{ sx: { height: 40 } }}
//                                         onChange={e => {
//                                             const v = e.target.value.toUpperCase().replace(/[^0-9A-Z]/g, "");
//                                             if (v.length <= 15) setGstInNumber(v);
//                                         }}
//                                     />
//                                     <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
//                                         {gstLoading ? <CircularProgress size={24} /> : gstValid === true ? <CheckCircleIcon color="success" /> : gstValid === false && gstInNumber ? <CancelIcon color="error" /> : null}
//                                     </Box>
//                                 </Box>
//                             )}

//                             <TextField size="small" fullWidth label="Distributor Name" value={loggedInUser?.userName || ""} disabled sx={compactInputStyle} />

//                             <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1, mt: 1 }}>
//                                 {Object.keys(initialState)
//                                     .filter(f => !["selectedOptions", "normalDropdown", "ProductKey", "WAKey", "PaymentMode", "Date", "CD", "CollectBy", "RcdBy", "ChequeNoOrTransNo", "Amt", "MobileAppUsers", "isWhatsAppKeyEnabled", "isMobileAppEnabled"].includes(f))
//                                     .map(field => (
//                                         <TextField size="small" key={field} label={field.replace(/([A-Z])/g, " $1").trim()} value={form[field] || ""} fullWidth disabled={!isNewMode} onChange={e => dispatch({ type: "UPDATE_FIELD", field, value: e.target.value })} sx={compactInputStyle} />
//                                     ))}

//                                 {/* Updated: Added loading indicator to WAKey TextField */}
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.6 }}>
//                                     <TextField size="small" label="WA Key" value={form.WAKey || ""} disabled fullWidth sx={{ ...compactInputStyle }} />
//                                     <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
//                                         {whatsAppKeyLoading ? <CircularProgress size={24} /> : null}
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.6 }}>
//                                     <TextField size="small" label="Product Key" value={form.ProductKey} disabled fullWidth sx={{ ...compactInputStyle, flex: 1 }} />
//                                     {/* Updated: Show CircularProgress and disable button during loading */}
//                                     <Button variant="contained" onClick={handleGenerateKey} sx={{ height: 40, whiteSpace: "nowrap" }} disabled={generateKeyLoading}>
//                                         {generateKeyLoading ? <CircularProgress size={24} color="inherit" /> : isNewMode ? "Generate" : "Update Key"}
//                                     </Button>
//                                 </Box>
//                             </Box>

//                             <Box sx={{ borderTop: "1px solid #e0e0e0", my: 2 }} />

//                             <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="payment-mode-label">Payment Mode</InputLabel>
//                                     <Select labelId="payment-mode-label" value={form.PaymentMode || "Bank"} label="Payment Mode" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: e.target.value })} >
//                                         <MenuItem value="Bank">Bank</MenuItem>
//                                         <MenuItem value="Cash">Cash</MenuItem>
//                                         <MenuItem value="UPI">UPI</MenuItem>
//                                     </Select>
//                                 </FormControl>

//                                 <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
//                                     <TextField size="small" label="Cheque No / Transaction No" value={form.ChequeNoOrTransNo} fullWidth onChange={e => dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: e.target.value })} sx={compactInputStyle} />
//                                     <DatePicker label="Date" value={form.Date ? dayjs(form.Date) : null} onChange={value => dispatch({ type: "UPDATE_FIELD", field: "Date", value: value })} format="DD-MM-YYYY" slotProps={{ textField: { sx: compactInputStyle } }} />
//                                 </Box>

//                                 <TextField size="small" label="Amount" value={form.Amt} fullWidth sx={compactInputStyle}
//                                     onChange={e => {
//                                         const v = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(v)) dispatch({ type: "UPDATE_FIELD", field: "Amt", value: v });
//                                     }}
//                                 />

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="cd-label">CD</InputLabel>
//                                     <Select labelId="cd-label" value={form.CD || "0"} label="CD" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CD", value: e.target.value })} >
//                                         <MenuItem value="1">Yes</MenuItem>
//                                         <MenuItem value="0">No</MenuItem>
//                                     </Select>
//                                 </FormControl>

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="collect-by-label">Collect By</InputLabel>
//                                     <Select labelId="collect-by-label" value={form.CollectBy || ""} label="Collect By" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: Number(e.target.value) })} >
//                                         {usersOptions.map(user => ( <MenuItem key={user.UserId} value={user.UserId}> {user.employeeName} </MenuItem> ))}
//                                     </Select>
//                                 </FormControl>

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="rcd-by-label">Rcd By</InputLabel>
//                                     <Select labelId="rcd-by-label" value={form.RcdBy || ""} label="Rcd By" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: Number(e.target.value) })} >
//                                         {usersOptions.map(user => ( <MenuItem key={user.UserId} value={user.UserId}> {user.employeeName} </MenuItem> ))}
//                                     </Select>
//                                 </FormControl>
//                             </Box>

//                             <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, gap: 1 }}>
//                                 <Button variant="contained" fullWidth onClick={isNewMode ? handleSubmit : handleUpdateKey} > {isNewMode ? "Submit New" : "Submit Update"} </Button>
//                                 <Button variant="contained" color="secondary" onClick={handleClear} fullWidth > Clear </Button>
//                             </Box>
//                             {keyError && <Typography color="error" sx={{ mt: 1 }}>{keyError}</Typography>}
//                         </Box>


//                         <Box sx={{ width: { xs: "100%", md: 300 } }}>
//                             <Paper elevation={3} sx={{ p: 1 }}>
//                                 <Typography variant="subtitle1" gutterBottom>LAN Version</Typography>
//                                 <FormControlLabel control={<Checkbox size="small" checked={form.selectedOptions.includes("99")} onChange={() => dispatch({ type: "TOGGLE_OPTION", option: "99" })} />} label="LAN Version?" />
//                                 <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
//                                     <FormControlLabel label="WhatsApp Key"
//                                         control={<Checkbox size="small" checked={form.isWhatsAppKeyEnabled} onChange={(e) => {
//                                             dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: e.target.checked });
//                                             if (e.target.checked) {
//                                                 handleGenerateWhatsAppKey();
//                                             } else {
//                                                 dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: "" });
//                                             }
//                                         }} />}
//                                     />

//                                     <FormControlLabel control={<Checkbox size="small" checked={form.isMobileAppEnabled} onChange={(e) => handleMobileAppToggle(e.target.checked)} />} label="Mobile App" />

//                                     {form.isMobileAppEnabled && (
//                                         <TextField size="small" label="Number of Mobile App Users" value={form.MobileAppUsers} fullWidth type="number" inputProps={{ min: 1, step: 1, pattern: "\\d*" }} sx={compactInputStyle}
//                                             onChange={(e) => {
//                                                 const v = e.target.value;
//                                                 if (v === "" || (/^\d+$/.test(v) && parseInt(v, 10) >= 1)) {
//                                                     dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: v });
//                                                 }
//                                             }}
//                                         />
//                                     )}
//                                 </Box>

//                                 <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>Select Features:</Typography>
//                                 <FormGroup
//                                     sx={{ display: "grid", gridTemplateColumns: "1fr", rowGap: 0.5,
//                                         "& .MuiFormControlLabel-root": { alignItems: "center", margin: 0, "& .MuiTypography-root": { fontSize: "0.875rem" } },
//                                         "& .MuiCheckbox-root": { p: 0.5 }
//                                     }}
//                                 >
//                                     {checkboxOptions.map(opt => (
//                                         <FormControlLabel key={opt.ModuleValue} control={<Checkbox size="small" checked={form.selectedOptions.includes(opt.ModuleValue)} onChange={() => dispatch({ type: "TOGGLE_OPTION", option: opt.ModuleValue })} />} label={opt.Label} />
//                                     ))}
//                                 </FormGroup>
//                             </Paper>
//                         </Box>
//                     </Box>
//                 </Box>
//             </LocalizationProvider>
//         </Container>
//     );
// }

// ---------------------------------------------------------------------------------------------------------------------------

//Updated code 2

// import React, { useEffect, useReducer, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { Container, Box, TextField, Button, Typography, CircularProgress, FormGroup, FormControlLabel, Checkbox, Paper, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import dayjs from "dayjs";

// // Initial form state
// const initialState = {
//     CompanyName: "", ItemCode: "", ContactPerson: "", MobileNo: "", EmailId: "",
//     Website: "", Address1: "", PinCode: "", Area: "", City: "", State: "",
//     Country: "", ProductKey: "", WAKey: "", selectedOptions: [], normalDropdown: "CompanyName",
//     PaymentMode: "Bank", ChequeNoOrTransNo: "", Date: null, Amt: "", CD: "0",
//     CollectBy: "", RcdBy: "", MobileAppUsers: "",
//     isWhatsAppKeyEnabled: false, isMobileAppEnabled: false
// };

// // Reducer handles all form state modifications
// function reducer(state, action) {
//     switch (action.type) {
//         case "UPDATE_FIELD":
//             return { ...state, [action.field]: action.value };
//         case "TOGGLE_OPTION":
//             return { ...state, selectedOptions: state.selectedOptions.includes(action.option) ? state.selectedOptions.filter(o => o !== action.option) : [...state.selectedOptions, action.option] };
//         case "SET_OPTIONS":
//             return { ...state, selectedOptions: action.options };
//         case "RESET":
//             return { ...initialState, CollectBy: state.CollectBy || action.loggedInUser?.UserId || "", RcdBy: state.RcdBy || action.loggedInUser?.UserId || "" };
//         default:
//             return state;
//     }
// }

// export default function GenerateKey({ loggedInUser, companyData, connectionString }) {
//     // Base URL for your backend API
//     const path = `http://192.168.1.248:3109`;
//     const pathh = connectionString;
//     const { state: locationState } = useLocation();
//     const isNewMode = locationState?.mode !== "update";
//     const companyId = companyData?.[0]?.CompId;

//     const [form, dispatch] = useReducer(reducer, {
//         ...initialState,
//         CollectBy: loggedInUser?.UserId || "",
//         RcdBy: loggedInUser?.UserId || ""
//     });

//     const [gstInNumber, setGstInNumber] = useState("");
//     const [gstValid, setGstValid] = useState(null);
//     const [gstError, setGstError] = useState("");
//     const [gstLoading, setGstLoading] = useState(false);
//     const [checkboxOptions, setCheckboxOptions] = useState([]);
//     const [usersOptions, setUsersOptions] = useState([]);
//     const [keyError, setKeyError] = useState("");
//     const [customerId, setCustomerId] = useState("");
//     const [id, setId] = useState(null);
//     const [searchText, setSearchText] = useState("");
//     const [searchResults, setSearchResults] = useState([]);
//     const [showResults, setShowResults] = useState(false);
//     const [generateKeyLoading, setGenerateKeyLoading] = useState(false);
//     const [whatsAppKeyLoading, setWhatsAppKeyLoading] = useState(false);

//     useEffect(() => {
//         axios.get(`${path}/api/features-list`).then(r => {
//             console.log(r.data);
//             setCheckboxOptions(r.data);
//         }).catch(console.error);
//         axios.get(`${path}/api/users`, { params: { companyId } }).then((res) => {
//             setUsersOptions(Array.isArray(res.data.data) ? res.data.data : []);
//         }).catch((error) => console.error("Error fetching users:", error));
//     }, [companyId]);

//     useEffect(() => {
//         if (locationState?.Id && !isNewMode) {
//             console.log("Received Id:", locationState.Id);
//             setId(locationState.Id);
//             axios.get(`${path}/api/members/get-data/${locationState.Id}`)
//                 .then((res) => {
//                     if (res.data.success) {
//                         const data = res.data.data;
//                         console.log('Fetched member data:', data);
//                         dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: data.CompanyName || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: data.ContactPerson || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ItemCode", value: data.ItemCode || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "MobileNo", value: data.MobileNo || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "EmailId", value: data.EmailId || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Website", value: data.Website || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Address1", value: data.Address1 || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Address2", value: data.Address2 || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Area", value: data.Area || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "City", value: data.City || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "State", value: data.State || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Country", value: data.Country || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: data.PinCode || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: data.ProductKey || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: data.WAKey || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: data.PaymentMode || "Bank" });
//                         dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: data.ChequeNoOrTransNo || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "Date", value: data.PaymentDate ? dayjs(data.PaymentDate) : null });
//                         dispatch({ type: "UPDATE_FIELD", field: "Amt", value: data.Amount || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "CD", value: data.CD || "0" });
//                         // Convert CollectById and RcdById to strings to match Select value type
//                         dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: data.CollectById ? String(data.CollectById) : "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: data.RcdById ? String(data.RcdById) : "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: data.MobileAppUsers || "" });
//                         dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: data.isWhatsAppKeyEnabled });
//                         dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: data.isMobileAppEnabled });

//                         // Handle SoftwareModule safely
//                         const moduleCodes = typeof data.SoftwareModule === 'string' ? data.SoftwareModule.split(',').map(code => code.trim()) : [];
//                         const selectedIds = checkboxOptions
//                             .filter(opt => moduleCodes.includes(opt.ModuleCode))
//                             .map(opt => opt.Id);

//                         // Decrypt ProductKey to get ModuleCode values and map to Ids
//                         const decryptedModuleCodes = decryptProductKey(data.ProductKey || "");
//                         const decryptedIds = checkboxOptions
//                             .filter(opt => decryptedModuleCodes.includes(opt.ModuleCode))
//                             .map(opt => opt.Id);

//                         // Combine and deduplicate selectedIds and decryptedIds
//                         const combinedIds = [...new Set([...selectedIds, ...decryptedIds])];
//                         dispatch({ type: "SET_OPTIONS", options: combinedIds });
//                         setCustomerId(data.CustomerID || "");
//                     } else {
//                         setKeyError(res.data.message || "Failed to fetch member data");
//                     }
//                 })
//                 .catch((error) => {
//                     console.error("Error fetching member data:", error);
//                     setKeyError("Error fetching member data");
//                 });
//         }
//     }, [locationState, isNewMode, checkboxOptions]);

//     // Decrypt ProductKey to extract ModuleCode values
//     const decryptProductKey = (productKey) => {
//         if (!productKey || productKey.length < 7) {
//             console.log("Invalid ProductKey for decryption:", productKey);
//             return [];
//         }

//         // Extract length from positions 6 and 7 (zero-based index: 5 and 6)
//         const lenStr = productKey.slice(5, 7);
//         const len = parseInt(lenStr, 10);
//         if (isNaN(len) || len <= 0) {
//             console.log("Invalid length in ProductKey:", lenStr);
//             return [];
//         }

//         // Take the last 'len' characters from the right
//         const moduleCodeStr = productKey.slice(-len);
//         if (moduleCodeStr.length !== len) {
//             console.log("ProductKey too short for specified length:", productKey, len);
//             return [];
//         }

//         // Extract two-digit ModuleCode values from the substring
//         const moduleCodes = [];
//         for (let i = 0; i < moduleCodeStr.length; i += 2) {
//             const code = moduleCodeStr.slice(i, i + 2);
//             if (code.length === 2) {
//                 moduleCodes.push(code);
//             }
//         }

//         console.log("Decrypted ModuleCodes:", moduleCodes);
//         return moduleCodes;
//     };

//     useEffect(() => {
//         if (usersOptions.length > 0 && loggedInUser?.UserId) {
//             if (!form.CollectBy) {
//                 dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: String(loggedInUser.UserId) });
//             }
//             if (!form.RcdBy) {
//                 dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: String(loggedInUser.UserId) });
//             }
//         }
//     }, [usersOptions, loggedInUser, form.CollectBy, form.RcdBy]);

//     const handleGstBlur = async (e) => {
//         const gstin = e.target.value.trim().toUpperCase();
//         if (gstin.length !== 15 || /[^0-9A-Z]/.test(gstin)) {
//             setGstError("GSTIN must be exactly 15 alphanumeric characters");
//             setGstValid(false);
//             dispatch({ type: "RESET", loggedInUser });
//             return;
//         }

//         setGstError("");
//         setGstLoading(true);

//         try {
//             const resp = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gstin } });
//             if (!resp.data.success) {
//                 setGstError(`GST API status: ${resp.data.status}`);
//                 setGstValid(false);
//                 dispatch({ type: "RESET", loggedInUser });
//             } else {
//                 const d = resp.data.data;
//                 dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: d.CompanyName || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: d.ContactPerson || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Address1", value: d.Address1 || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Address2", value: d.Address2 || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Area", value: d.Area || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "City", value: d.City || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "State", value: d.State || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Country", value: d.Country || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: d.PinCode || "" });
//                 dispatch({ type: "UPDATE_FIELD", field: "Website", value: d.Website || "" });
//                 setGstInNumber(gstin);
//                 setGstValid(true);
//             }
//         } catch (err) {
//             console.error("GST lookup failed:", err);
//             setGstError("Unable to fetch GST details");
//             setGstValid(false);
//             dispatch({ type: "RESET", loggedInUser });
//         } finally {
//             setGstLoading(false);
//         }
//     };

//     const handleGenerateWhatsAppKey = async () => {
//         setKeyError("");
//         setWhatsAppKeyLoading(true);
//         try {
//             const { WAKey } = (await axios.post(`${path}/api/members/generate-whatsapp-key`, { selectedOptions: form.selectedOptions })).data;
//             console.log('Generated WAKey:', WAKey);
//             dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: WAKey });
//         } catch (err) {
//             console.error('Error generating WA key:', err);
//             setKeyError("Error generating WhatsApp Key.");
//         } finally {
//             setWhatsAppKeyLoading(false);
//         }
//     };

//     const handleMobileAppToggle = (checked) => {
//         dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: checked });
//         const current = form.MobileAppUsers;
//         if (checked && (!current || !/^\d+$/.test(current) || parseInt(current, 10) < 1)) {
//             dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: "1" });
//             console.log('Mobile app enabled - defaulting MobileAppUsers to 1');
//         } else {
//             console.log(`Mobile app ${checked ? 'enabled' : 'disabled'}, MobileAppUsers: ${current}`);
//         }
//     };

//     const handleSubmit = async () => {
//         if (!form.CompanyName || !form.MobileNo || !form.selectedOptions.length) {
//             setKeyError("Company Name, Mobile No, and at least one feature are required.");
//             return;
//         }
//         try {
//             setKeyError("");
//             const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
//             const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;

//             const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

//             const payload = {
//                 ...form,
//                 PinCode: form.PinCode,
//                 selectedOptions: form.selectedOptions,
//                 CustomerID: customerId,
//                 ProductKey: form.ProductKey,
//                 WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
//                 MobileAppUsers: mobileUsers,
//                 isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
//                 isMobileAppEnabled: !!form.isMobileAppEnabled,
//                 DName: loggedInUser?.userName,
//                 PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
//                 CD: parseInt(form.CD, 10),
//                 CollectById: collectByUser?.UserId || null,
//                 CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
//                 RcdById: rcdByUser?.UserId || null,
//                 RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
//             };

//             console.log("submit payload", payload);
//             const resp = await axios.post(`${path}/api/members/insertClient`, payload);
//             if (resp.data.success) {
//                 alert("Client created successfully!");
//                 dispatch({ type: "RESET", loggedInUser });
//                 setCustomerId("");
//                 setId(null);
//                 setGstInNumber("");
//                 setGstValid(null);
//             } else {
//                 setKeyError("Server rejected creation: " + (resp.data.message || ""));
//             }
//         } catch (err) {
//             console.error("Create member error:", err);
//             setKeyError("Error creating member.");
//         }
//     };

//     const handleGenerateKey = async () => {
//         setKeyError("");
//         if (!form.selectedOptions.length) {
//             setKeyError("Select at least one feature.");
//             return;
//         }
//         setGenerateKeyLoading(true);
//         try {
//             const moduleCodes = form.selectedOptions.map(id => {
//                 const option = checkboxOptions.find(opt => opt.Id === id);
//                 return option ? option.ModuleCode : null;
//             }).filter(code => code !== null);
//             console.log("Sending moduleCodes:", moduleCodes);
//             const { ProductKey, customerId: cid } = (await axios.post(`${path}/api/members/generate-key`, { selectedOptions: moduleCodes })).data;
//             console.log('Generated ProductKey:', ProductKey, 'cid:', cid);
//             dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: ProductKey });
//             setCustomerId(cid);
//         } catch (err) {
//             console.error('Error generating product key:', err);
//             setKeyError("Error generating key.");
//         } finally {
//             setGenerateKeyLoading(false);
//         }
//     };

//     const handleUpdateKey = async () => {
//         if (!id) {
//             setKeyError("No record selected.");
//             return;
//         }
//         if (!form.ProductKey) {
//             setKeyError("Nothing to update—Product Key is empty.");
//             return;
//         }
//         setGenerateKeyLoading(true);
//         try {
//             setKeyError("");
//             const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
//             const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;
//             const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

//             const payload = {
//                 subscribedFeatures: form.selectedOptions,
//                 ProductKey: form.ProductKey,
//                 WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
//                 MobileAppUsers: mobileUsers,
//                 isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
//                 isMobileAppEnabled: !!form.isMobileAppEnabled,
//                 PaymentMode: form.PaymentMode,
//                 ChequeNoOrTransNo: form.ChequeNoOrTransNo,
//                 PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
//                 Amount: form.Amt ? parseFloat(form.Amt) : null,
//                 CD: parseInt(form.CD, 10),
//                 CollectById: collectByUser?.UserId || null,
//                 CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
//                 RcdById: rcdByUser?.UserId || null,
//                 RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
//             };
//             console.log("update payload", payload);
//             const resp = await axios.put(`${path}/api/members/update-key/${id}`, payload);
//             if (resp.data.success) {
//                 alert("Product Key updated!");
//             } else {
//                 setKeyError(resp.data.message || "Failed to update Product Key");
//             }
//         } catch (err) {
//             console.error("Error updating Product Key:", err);
//             setKeyError("Server error while updating Product Key.");
//         } finally {
//             setGenerateKeyLoading(false);
//         }
//     };

//     const handleClear = () => {
//         dispatch({ type: "RESET", loggedInUser });
//         setGstInNumber("");
//         setGstValid(null);
//         setGstError("");
//         setKeyError("");
//         setCustomerId("");
//         setId(null);
//         setSearchText("");
//         setSearchResults([]);
//         setShowResults(false);
//         console.log('Form cleared');
//     };

//     const compactInputStyle = { "& .MuiInputBase-root": { height: 40 }, "& .MuiInputLabel-root": { fontSize: "0.75rem" }, mt: 0.6 };

//     return (
//         <Container sx={{ maxWidth: "1300px !important", width: "100%" }}>
//             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                 <Box sx={{ mt: 1, mb: 1 }}>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                         <Typography variant="h5">{isNewMode ? "Generate New Key" : "Update Existing Key"}</Typography>
//                         <FormControlLabel control={<Checkbox checked={isNewMode} onChange={handleClear} />} label="New Mode?" />
//                     </Box>

//                     <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>
//                         <Box component="form" onSubmit={e => e.preventDefault()} sx={{ flex: 1 }}>
//                             {isNewMode && (
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//                                     <TextField size="small" fullWidth label="GST No" value={gstInNumber} onBlur={handleGstBlur} error={!!gstError} helperText={gstError} InputProps={{ sx: { height: 40 } }}
//                                         onChange={e => {
//                                             const v = e.target.value.toUpperCase().replace(/[^0-9A-Z]/g, "");
//                                             if (v.length <= 15) setGstInNumber(v);
//                                         }}
//                                     />
//                                     <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
//                                         {gstLoading ? <CircularProgress size={24} /> : gstValid === true ? <CheckCircleIcon color="success" /> : gstValid === false && gstInNumber ? <CancelIcon color="error" /> : null}
//                                     </Box>
//                                 </Box>
//                             )}

//                             <TextField size="small" fullWidth label="Distributor Name" value={loggedInUser?.userName || ""} disabled sx={compactInputStyle} />

//                             <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1, mt: 1 }}>
//                                 {Object.keys(initialState)
//                                     .filter(f => !["selectedOptions", "normalDropdown", "ProductKey", "WAKey", "PaymentMode", "Date", "CD", "CollectBy", "RcdBy", "ChequeNoOrTransNo", "Amt", "MobileAppUsers", "isWhatsAppKeyEnabled", "isMobileAppEnabled"].includes(f))
//                                     .map(field => (
//                                         <TextField size="small" key={field} label={field.replace(/([A-Z])/g, " $1").trim()} value={form[field] || ""} fullWidth disabled={!isNewMode} onChange={e => dispatch({ type: "UPDATE_FIELD", field, value: e.target.value })} sx={compactInputStyle} />
//                                     ))}

//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.6 }}>
//                                     <TextField size="small" label="WA Key" value={form.WAKey || ""} disabled fullWidth sx={{ ...compactInputStyle }} />
//                                     <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
//                                         {whatsAppKeyLoading ? <CircularProgress size={24} /> : null}
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.6 }}>
//                                     <TextField size="small" label="Product Key" value={form.ProductKey} disabled fullWidth sx={{ ...compactInputStyle, flex: 1 }} />
//                                     <Button variant="contained" onClick={handleGenerateKey} sx={{ height: 40, whiteSpace: "nowrap" }} disabled={generateKeyLoading}>
//                                         {generateKeyLoading ? <CircularProgress size={24} color="inherit" /> : isNewMode ? "Generate" : "Update Key"}
//                                     </Button>
//                                 </Box>
//                             </Box>

//                             <Box sx={{ borderTop: "1px solid #e0e0e0", my: 2 }} />

//                             <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="payment-mode-label">Payment Mode</InputLabel>
//                                     <Select labelId="payment-mode-label" value={form.PaymentMode || "Bank"} label="Payment Mode" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: e.target.value })}>
//                                         <MenuItem value="Bank">Bank</MenuItem>
//                                         <MenuItem value="Cash">Cash</MenuItem>
//                                         <MenuItem value="UPI">UPI</MenuItem>
//                                     </Select>
//                                 </FormControl>

//                                 <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
//                                     <TextField size="small" label="Cheque No / Transaction No" value={form.ChequeNoOrTransNo} fullWidth onChange={e => dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: e.target.value })} sx={compactInputStyle} />
//                                     <DatePicker label="Date" value={form.Date ? dayjs(form.Date) : null} onChange={value => dispatch({ type: "UPDATE_FIELD", field: "Date", value: value })} format="DD-MM-YYYY" slotProps={{ textField: { sx: compactInputStyle } }} />
//                                 </Box>

//                                 <TextField size="small" label="Amount" value={form.Amt} fullWidth sx={compactInputStyle}
//                                     onChange={e => {
//                                         const v = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(v)) dispatch({ type: "UPDATE_FIELD", field: "Amt", value: v });
//                                     }}
//                                 />

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="cd-label">CD</InputLabel>
//                                     <Select labelId="cd-label" value={form.CD || "0"} label="CD" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CD", value: e.target.value })}>
//                                         <MenuItem value="1">Yes</MenuItem>
//                                         <MenuItem value="0">No</MenuItem>
//                                     </Select>
//                                 </FormControl>

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="collect-by-label">Collect By</InputLabel>
//                                     <Select labelId="collect-by-label" value={form.CollectBy || ""} label="Collect By" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: String(e.target.value) })}>
//                                         {usersOptions.map(user => (<MenuItem key={user.UserId} value={String(user.UserId)}>{user.employeeName}</MenuItem>))}
//                                     </Select>
//                                 </FormControl>

//                                 <FormControl fullWidth sx={compactInputStyle}>
//                                     <InputLabel id="rcd-by-label">Rcd By</InputLabel>
//                                     <Select labelId="rcd-by-label" value={form.RcdBy || ""} label="Rcd By" onChange={e => dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: String(e.target.value) })}>
//                                         {usersOptions.map(user => (<MenuItem key={user.UserId} value={String(user.UserId)}>{user.employeeName}</MenuItem>))}
//                                     </Select>
//                                 </FormControl>
//                             </Box>

//                             <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, gap: 1 }}>
//                                 <Button variant="contained" fullWidth onClick={isNewMode ? handleSubmit : handleUpdateKey}>{isNewMode ? "Submit New" : "Submit Update"}</Button>
//                                 <Button variant="contained" color="secondary" onClick={handleClear} fullWidth>Clear</Button>
//                             </Box>
//                             {keyError && <Typography color="error" sx={{ mt: 1 }}>{keyError}</Typography>}
//                         </Box>

//                         <Box sx={{ width: { xs: "100%", md: 300 } }}>
//                             <Paper elevation={3} sx={{ p: 1 }}>
//                                 <Typography variant="subtitle1" gutterBottom>LAN Version</Typography>
//                                 <FormControlLabel control={<Checkbox size="small" checked={form.selectedOptions.includes("99")} onChange={() => dispatch({ type: "TOGGLE_OPTION", option: "99" })} />} label="LAN Version?" />
//                                 <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
//                                     <FormControlLabel label="WhatsApp Key"
//                                         control={<Checkbox size="small" checked={form.isWhatsAppKeyEnabled} onChange={(e) => {
//                                             dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: e.target.checked });
//                                             if (e.target.checked) {
//                                                 handleGenerateWhatsAppKey();
//                                             } else {
//                                                 dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: "" });
//                                             }
//                                         }} />}
//                                     />

//                                     <FormControlLabel control={<Checkbox size="small" checked={form.isMobileAppEnabled} onChange={(e) => handleMobileAppToggle(e.target.checked)} />} label="Mobile App" />

//                                     {form.isMobileAppEnabled && (
//                                         <TextField size="small" label="Number of Mobile App Users" value={form.MobileAppUsers} fullWidth type="number" inputProps={{ min: 1, step: 1, pattern: "\\d*" }} sx={compactInputStyle}
//                                             onChange={(e) => {
//                                                 const v = e.target.value;
//                                                 if (v === "" || (/^\d+$/.test(v) && parseInt(v, 10) >= 1)) {
//                                                     dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: v });
//                                                 }
//                                             }}
//                                         />
//                                     )}
//                                 </Box>

//                                 <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>Select Features:</Typography>
//                                 <FormGroup
//                                     sx={{
//                                         display: "grid",
//                                         gridTemplateColumns: "1fr",
//                                         rowGap: 0.5,
//                                         "& .MuiFormControlLabel-root": { alignItems: "center", margin: 0, "& .MuiTypography-root": { fontSize: "0.875rem" } },
//                                         "& .MuiCheckbox-root": { p: 0.5 },
//                                     }}
//                                 >
//                                     {checkboxOptions.map((opt) => (
//                                         <FormControlLabel
//                                             key={opt.Id}
//                                             control={
//                                                 <Checkbox
//                                                     size="small"
//                                                     checked={form.selectedOptions.includes(opt.Id)}
//                                                     onChange={() => dispatch({ type: "TOGGLE_OPTION", option: opt.Id })}
//                                                 />
//                                             }
//                                             label={opt.Label}
//                                         />
//                                     ))}
//                                 </FormGroup>
//                             </Paper>
//                         </Box>
//                     </Box>
//                 </Box>
//             </LocalizationProvider>
//         </Container>
//     );
// }


import React, { useEffect, useReducer, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Container, Box, TextField, Button, Typography, CircularProgress, FormGroup, FormControlLabel, Checkbox, Paper, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import dayjs from "dayjs";

// Initial form state
const initialState = {
    CompanyName: "", ItemCode: "", ContactPerson: "", MobileNo: "", EmailId: "",
    Website: "", Address1: "", PinCode: "", Area: "", City: "", State: "",
    Country: "", ProductKey: "", WAKey: "", selectedOptions: [], normalDropdown: "CompanyName",
    PaymentMode: "Bank", ChequeNoOrTransNo: "", Date: null, Amt: "", CD: "0",
    CollectBy: "", RcdBy: "", MobileAppUsers: "",
    isWhatsAppKeyEnabled: false, isMobileAppEnabled: false
};

// Reducer handles all form state modifications
function reducer(state, action) {
    switch (action.type) {
        case "UPDATE_FIELD":
            return { ...state, [action.field]: action.value };
        case "TOGGLE_OPTION":
            return { ...state, selectedOptions: state.selectedOptions.includes(action.option) ? state.selectedOptions.filter(o => o !== action.option) : [...state.selectedOptions, action.option] };
        case "SET_OPTIONS":
            return { ...state, selectedOptions: action.options };
        case "RESET":
            return { ...initialState, CollectBy: state.CollectBy || action.loggedInUser?.UserId || "", RcdBy: state.RcdBy || action.loggedInUser?.UserId || "" };
        default:
            return state;
    }
}

export default function GenerateKey({ loggedInUser, companyData, connectionString }) {
    // Base URL for your backend API
    const path = `http://192.168.1.248:3109`;
    const pathh = connectionString;
    const { state: locationState } = useLocation();
    const isNewMode = locationState?.mode !== "update";
    const companyId = companyData?.[0]?.CompId;

    const [form, dispatch] = useReducer(reducer, {
        ...initialState,
        CollectBy: loggedInUser?.UserId || "",
        RcdBy: loggedInUser?.UserId || ""
    });

    const [gstInNumber, setGstInNumber] = useState("");
    const [gstValid, setGstValid] = useState(null);
    const [gstError, setGstError] = useState("");
    const [gstLoading, setGstLoading] = useState(false);
    const [checkboxOptions, setCheckboxOptions] = useState([]);
    const [usersOptions, setUsersOptions] = useState([]);
    const [keyError, setKeyError] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [id, setId] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [generateKeyLoading, setGenerateKeyLoading] = useState(false);
    const [whatsAppKeyLoading, setWhatsAppKeyLoading] = useState(false);

    useEffect(() => {
        axios.get(`${path}/api/features-list`).then(r => {
            console.log(r.data);
            setCheckboxOptions(r.data);
        }).catch(console.error);
        axios.get(`${path}/api/users`, { params: { companyId } }).then((res) => {
            setUsersOptions(Array.isArray(res.data.data) ? res.data.data : []);
        }).catch((error) => console.error("Error fetching users:", error));
    }, [companyId]);

    useEffect(() => {
        if (locationState?.Id && !isNewMode) {
            console.log("Received Id:", locationState.Id);
            setId(locationState.Id);
            axios.get(`${path}/api/members/get-data/${locationState.Id}`)
                .then((res) => {
                    if (res.data.success) {
                        const data = res.data.data;
                        console.log('Fetched member data:', data);
                        dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: data.CompanyName || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: data.ContactPerson || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "ItemCode", value: data.ItemCode || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "MobileNo", value: data.MobileNo || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "EmailId", value: data.EmailId || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Website", value: data.Website || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Address1", value: data.Address1 || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Address2", value: data.Address2 || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Area", value: data.Area || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "City", value: data.City || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "State", value: data.State || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Country", value: data.Country || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: data.PinCode || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: data.ProductKey || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: data.WAKey || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: data.PaymentMode || "Bank" });
                        dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: data.ChequeNoOrTransNo || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "Date", value: data.PaymentDate ? dayjs(data.PaymentDate) : null });
                        dispatch({ type: "UPDATE_FIELD", field: "Amt", value: data.Amount || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "CD", value: data.CD || "0" });
                        dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: data.CollectById ? String(data.CollectById) : "" });
                        dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: data.RcdById ? String(data.RcdById) : "" });
                        dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: data.MobileAppUsers || "" });
                        dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: data.isWhatsAppKeyEnabled });
                        dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: data.isMobileAppEnabled });

                        const moduleCodes = typeof data.SoftwareModule === 'string' ? data.SoftwareModule.split(',').map(code => code.trim()) : [];
                        const selectedIds = checkboxOptions
                            .filter(opt => moduleCodes.includes(opt.ModuleCode))
                            .map(opt => opt.Id);

                        const decryptedModuleCodes = decryptProductKey(data.ProductKey || "");
                        const decryptedIds = checkboxOptions
                            .filter(opt => decryptedModuleCodes.includes(opt.ModuleCode))
                            .map(opt => opt.Id);

                        const combinedIds = [...new Set([...selectedIds, ...decryptedIds])];
                        dispatch({ type: "SET_OPTIONS", options: combinedIds });
                        setCustomerId(data.CustomerID || "");
                    } else {
                        setKeyError(res.data.message || "Failed to fetch member data");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching member data:", error);
                    setKeyError("Error fetching member data");
                });
        }
    }, [locationState, isNewMode, checkboxOptions]);

    const decryptProductKey = (productKey) => {
        if (!productKey || productKey.length < 7) {
            console.log("Invalid ProductKey for decryption:", productKey);
            return [];
        }

        const lenStr = productKey.slice(5, 7);
        const len = parseInt(lenStr, 10);
        if (isNaN(len) || len <= 0) {
            console.log("Invalid length in ProductKey:", lenStr);
            return [];
        }

        const moduleCodeStr = productKey.slice(-len);
        if (moduleCodeStr.length !== len) {
            console.log("ProductKey too short for specified length:", productKey, len);
            return [];
        }

        const moduleCodes = [];
        for (let i = 0; i < moduleCodeStr.length; i += 2) {
            const code = moduleCodeStr.slice(i, i + 2);
            if (code.length === 2) {
                moduleCodes.push(code);
            }
        }

        console.log("Decrypted ModuleCodes:", moduleCodes);
        return moduleCodes;
    };

    useEffect(() => {
        if (usersOptions.length > 0 && loggedInUser?.UserId) {
            if (!form.CollectBy) {
                dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: String(loggedInUser.UserId) });
            }
            if (!form.RcdBy) {
                dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: String(loggedInUser.UserId) });
            }
        }
    }, [usersOptions, loggedInUser, form.CollectBy, form.RcdBy]);

    const handleGstBlur = async (e) => {
        const gstin = e.target.value.trim().toUpperCase();
        if (gstin.length !== 15 || /[^0-9A-Z]/.test(gstin)) {
            setGstError("GSTIN must be exactly 15 alphanumeric characters");
            setGstValid(false);
            dispatch({ type: "RESET", loggedInUser });
            return;
        }

        setGstError("");
        setGstLoading(true);

        try {
            const resp = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gstin } });
            if (!resp.data.success) {
                setGstError(`GST API status: ${resp.data.status}`);
                setGstValid(false);
                dispatch({ type: "RESET", loggedInUser });
            } else {
                const d = resp.data.data;
                dispatch({ type: "UPDATE_FIELD", field: "CompanyName", value: d.CompanyName || "" });
                dispatch({ type: "UPDATE_FIELD", field: "ContactPerson", value: d.ContactPerson || "" });
                dispatch({ type: "UPDATE_FIELD", field: "Address1", value: d.Address1 || "" });
                dispatch({ type: "UPDATE_FIELD", field: "Address2", value: d.Address2 || "" });
                dispatch({ type: "UPDATE_FIELD", field: "Area", value: d.Area || "" });
                dispatch({ type: "UPDATE_FIELD", field: "City", value: d.City || "" });
                dispatch({ type: "UPDATE_FIELD", field: "State", value: d.State || "" });
                dispatch({ type: "UPDATE_FIELD", field: "Country", value: d.Country || "" });
                dispatch({ type: "UPDATE_FIELD", field: "PinCode", value: d.PinCode || "" });
                dispatch({ type: "UPDATE_FIELD", field: "Website", value: d.Website || "" });
                setGstInNumber(gstin);
                setGstValid(true);
            }
        } catch (err) {
            console.error("GST lookup failed:", err);
            setGstError("Unable to fetch GST details");
            setGstValid(false);
            dispatch({ type: "RESET", loggedInUser });
        } finally {
            setGstLoading(false);
        }
    };

    const handleGenerateWhatsAppKey = async () => {
        setKeyError("");
        setWhatsAppKeyLoading(true);
        try {
            const { WAKey } = (await axios.post(`${path}/api/members/generate-whatsapp-key`, { selectedOptions: form.selectedOptions })).data;
            console.log('Generated WAKey:', WAKey);
            dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: WAKey });
        } catch (err) {
            console.error('Error generating WA key:', err);
            setKeyError("Error generating WhatsApp Key.");
        } finally {
            setWhatsAppKeyLoading(false);
        }
    };

    const handleMobileAppToggle = (checked) => {
        dispatch({ type: "UPDATE_FIELD", field: "isMobileAppEnabled", value: checked });
        const current = form.MobileAppUsers;
        if (checked && (!current || !/^\d+$/.test(current) || parseInt(current, 10) < 1)) {
            dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: "1" });
            console.log('Mobile app enabled - defaulting MobileAppUsers to 1');
        } else {
            console.log(`Mobile app ${checked ? 'enabled' : 'disabled'}, MobileAppUsers: ${current}`);
        }
    };

    const handleSubmit = async () => {
        if (!form.CompanyName || !form.MobileNo || !form.selectedOptions.length) {
            setKeyError("Company Name, Mobile No, and at least one feature are required.");
            return;
        }
        try {
            setKeyError("");
            const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
            const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;

            const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

            const payload = {
                ...form,
                PinCode: form.PinCode,
                selectedOptions: form.selectedOptions,
                CustomerID: customerId,
                ProductKey: form.ProductKey,
                WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
                MobileAppUsers: mobileUsers,
                isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
                isMobileAppEnabled: !!form.isMobileAppEnabled,
                DName: loggedInUser?.userName,
                PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
                CD: parseInt(form.CD, 10),
                CollectById: collectByUser?.UserId || null,
                CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
                RcdById: rcdByUser?.UserId || null,
                RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
            };

            console.log("submit payload", payload);
            const resp = await axios.post(`${path}/api/members/insertClient`, payload);
            if (resp.data.success) {
                alert("Client created successfully!");
                dispatch({ type: "RESET", loggedInUser });
                setCustomerId("");
                setId(null);
                setGstInNumber("");
                setGstValid(null);
            } else {
                setKeyError("Server rejected creation: " + (resp.data.message || ""));
            }
        } catch (err) {
            console.error("Create member error:", err);
            setKeyError("Error creating member.");
        }
    };

    const handleGenerateKey = async () => {
        setKeyError("");
        if (!form.selectedOptions.length) {
            setKeyError("Select at least one feature.");
            return;
        }
        setGenerateKeyLoading(true);
        try {
            const moduleCodes = form.selectedOptions.map(id => {
                const option = checkboxOptions.find(opt => opt.Id === id);
                return option ? option.ModuleCode : null;
            }).filter(code => code !== null);
            console.log("Sending moduleCodes:", moduleCodes);
            const { ProductKey, customerId: cid } = (await axios.post(`${path}/api/members/generate-key`, { selectedOptions: moduleCodes })).data;
            console.log('Generated ProductKey:', ProductKey, 'cid:', cid);
            dispatch({ type: "UPDATE_FIELD", field: "ProductKey", value: ProductKey });
            setCustomerId(cid);
        } catch (err) {
            console.error('Error generating product key:', err);
            setKeyError("Error generating key.");
        } finally {
            setGenerateKeyLoading(false);
        }
    };

    const handleUpdateKey = async () => {
        if (!id) {
            setKeyError("No record selected.");
            return;
        }
        if (!form.ProductKey) {
            setKeyError("Nothing to update—Product Key is empty.");
            return;
        }
        setGenerateKeyLoading(true);
        try {
            setKeyError("");
            const collectByUser = usersOptions.find(u => u.UserId === Number(form.CollectBy)) || null;
            const rcdByUser = usersOptions.find(u => u.UserId === Number(form.RcdBy)) || null;
            const mobileUsers = form.isMobileAppEnabled && form.MobileAppUsers && /^\d+$/.test(form.MobileAppUsers) && parseInt(form.MobileAppUsers, 10) > 0 ? parseInt(form.MobileAppUsers, 10) : null;

            const payload = {
                subscribedFeatures: form.selectedOptions,
                ProductKey: form.ProductKey,
                WAKey: form.isWhatsAppKeyEnabled ? form.WAKey : "",
                MobileAppUsers: mobileUsers,
                isWhatsAppKeyEnabled: !!form.isWhatsAppKeyEnabled,
                isMobileAppEnabled: !!form.isMobileAppEnabled,
                PaymentMode: form.PaymentMode,
                ChequeNoOrTransNo: form.ChequeNoOrTransNo,
                PaymentDate: form.Date ? dayjs(form.Date).format("YYYY-MM-DD") : null,
                Amount: form.Amt ? parseFloat(form.Amt) : null,
                CD: parseInt(form.CD, 10),
                CollectById: collectByUser?.UserId || null,
                CollectByName: collectByUser?.employeeName || (loggedInUser?.userName || ""),
                RcdById: rcdByUser?.UserId || null,
                RcdByName: rcdByUser?.employeeName || (loggedInUser?.userName || "")
            };
            console.log("update payload", payload);
            const resp = await axios.put(`${path}/api/members/update-key/${id}`, payload);
            if (resp.data.success) {
                alert("Product Key updated!");
            } else {
                setKeyError(resp.data.message || "Failed to update Product Key");
            }
        } catch (err) {
            console.error("Error updating Product Key:", err);
            setKeyError("Server error while updating Product Key.");
        } finally {
            setGenerateKeyLoading(false);
        }
    };

    const handleClear = () => {
        dispatch({ type: "RESET", loggedInUser });
        setGstInNumber("");
        setGstValid(null);
        setGstError("");
        setKeyError("");
        setCustomerId("");
        setId(null);
        setSearchText("");
        setSearchResults([]);
        setShowResults(false);
        console.log('Form cleared');
    };

    const compactInputStyle = {
        "& .MuiInputBase-root": { height: { xs: 36, sm: 40 } },
        "& .MuiInputLabel-root": { fontSize: { xs: "0.7rem", sm: "0.75rem" } },
        mt: { xs: 0.5, sm: 0.6 }
    };

    return (
        <Container sx={{ maxWidth: { xs: "100%", sm: "600px", md: "960px", lg: "1300px" }, width: "100%", px: { xs: 1, sm: 2 } }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                <Box sx={{ mt: { xs: 1, sm: 2 }, mb: { xs: 1, sm: 2 } }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: { xs: 1, sm: 2 } }}>
                        <Typography variant="h5" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" } }}>
                            {isNewMode ? "Generate New Key" : "Update Existing Key"}
                        </Typography>
                        <FormControlLabel
                            control={<Checkbox checked={isNewMode} onChange={handleClear} />}
                            label="New Mode?"
                            sx={{ "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "0.875rem" } } }}
                        />
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "column", md: "row" }, gap: { xs: 1, sm: 2 } }}>
                        <Box component="form" onSubmit={e => e.preventDefault()} sx={{ flex: 1 }}>
                            {isNewMode && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: { xs: 1, sm: 2 } }}>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        label="GST No"
                                        value={gstInNumber}
                                        onBlur={handleGstBlur}
                                        error={!!gstError}
                                        helperText={gstError}
                                        InputProps={{ sx: { height: { xs: 36, sm: 40 } } }}
                                        onChange={e => {
                                            const v = e.target.value.toUpperCase().replace(/[^0-9A-Z]/g, "");
                                            if (v.length <= 15) setGstInNumber(v);
                                        }}
                                        sx={{ "& .MuiInputLabel-root": { fontSize: { xs: "0.7rem", sm: "0.75rem" } } }}
                                    />
                                    <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
                                        {gstLoading ? <CircularProgress size={20} /> : gstValid === true ? <CheckCircleIcon color="success" /> : gstValid === false && gstInNumber ? <CancelIcon color="error" /> : null}
                                    </Box>
                                </Box>
                            )}

                            <TextField
                                size="small"
                                fullWidth
                                label="Distributor Name"
                                value={loggedInUser?.userName || ""}
                                disabled
                                sx={compactInputStyle}
                            />

                            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr" }, gap: { xs: 0.5, sm: 1 }, mt: { xs: 0.5, sm: 1 } }}>
                                {Object.keys(initialState)
                                    .filter(f => !["selectedOptions", "normalDropdown", "ProductKey", "WAKey", "PaymentMode", "Date", "CD", "CollectBy", "RcdBy", "ChequeNoOrTransNo", "Amt", "MobileAppUsers", "isWhatsAppKeyEnabled", "isMobileAppEnabled"].includes(f))
                                    .map(field => (
                                        <TextField
                                            size="small"
                                            key={field}
                                            label={field.replace(/([A-Z])/g, " $1").trim()}
                                            value={form[field] || ""}
                                            fullWidth
                                            disabled={!isNewMode}
                                            onChange={e => dispatch({ type: "UPDATE_FIELD", field, value: e.target.value })}
                                            sx={compactInputStyle}
                                        />
                                    ))}

                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: { xs: 0.5, sm: 0.6 } }}>
                                    <TextField
                                        size="small"
                                        label="WA Key"
                                        value={form.WAKey || ""}
                                        disabled
                                        fullWidth
                                        sx={compactInputStyle}
                                    />
                                    <Box sx={{ width: 30, display: "flex", justifyContent: "center" }}>
                                        {whatsAppKeyLoading ? <CircularProgress size={20} /> : null}
                                    </Box>
                                </Box>

                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: { xs: 0.5, sm: 0.6 } }}>
                                    <TextField
                                        size="small"
                                        label="Product Key"
                                        value={form.ProductKey}
                                        disabled
                                        fullWidth
                                        sx={{ ...compactInputStyle, flex: 1 }}
                                    />
                                    <Button
                                        variant="contained"
                                        onClick={handleGenerateKey}
                                        sx={{ height: { xs: 36, sm: 40 }, fontSize: { xs: "0.7rem", sm: "0.875rem" }, px: { xs: 1, sm: 2 }, whiteSpace: "nowrap" }}
                                        disabled={generateKeyLoading}
                                    >
                                        {generateKeyLoading ? <CircularProgress size={20} color="inherit" /> : isNewMode ? "Generate" : "Update Key"}
                                    </Button>
                                </Box>
                            </Box>

                            <Box sx={{ borderTop: "1px solid #e0e0e0", my: { xs: 1, sm: 2 } }} />

                            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr" }, gap: { xs: 0.5, sm: 1 } }}>
                                <FormControl fullWidth sx={compactInputStyle}>
                                    <InputLabel id="payment-mode-label">Payment Mode</InputLabel>
                                    <Select
                                        labelId="payment-mode-label"
                                        value={form.PaymentMode || "Bank"}
                                        label="Payment Mode"
                                        onChange={e => dispatch({ type: "UPDATE_FIELD", field: "PaymentMode", value: e.target.value })}
                                        sx={{ height: { xs: 36, sm: 40 } }}
                                    >
                                        <MenuItem value="Bank">Bank</MenuItem>
                                        <MenuItem value="Cash">Cash</MenuItem>
                                        <MenuItem value="UPI">UPI</MenuItem>
                                    </Select>
                                </FormControl>

                                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: { xs: 0.5, sm: 1 } }}>
                                    <TextField
                                        size="small"
                                        label="Cheque No / Transaction No"
                                        value={form.ChequeNoOrTransNo}
                                        fullWidth
                                        onChange={e => dispatch({ type: "UPDATE_FIELD", field: "ChequeNoOrTransNo", value: e.target.value })}
                                        sx={compactInputStyle}
                                    />
                                    <DatePicker
                                        label="Date"
                                        value={form.Date ? dayjs(form.Date) : null}
                                        onChange={value => dispatch({ type: "UPDATE_FIELD", field: "Date", value: value })}
                                        format="DD-MM-YYYY"
                                        slotProps={{ textField: { sx: compactInputStyle } }}
                                    />
                                </Box>

                                <TextField
                                    size="small"
                                    label="Amount"
                                    value={form.Amt}
                                    fullWidth
                                    sx={compactInputStyle}
                                    onChange={e => {
                                        const v = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(v)) dispatch({ type: "UPDATE_FIELD", field: "Amt", value: v });
                                    }}
                                />

                                <FormControl fullWidth sx={compactInputStyle}>
                                    <InputLabel id="cd-label">CD</InputLabel>
                                    <Select
                                        labelId="cd-label"
                                        value={form.CD || "0"}
                                        label="CD"
                                        onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CD", value: e.target.value })}
                                        sx={{ height: { xs: 36, sm: 40 } }}
                                    >
                                        <MenuItem value="1">Yes</MenuItem>
                                        <MenuItem value="0">No</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth sx={compactInputStyle}>
                                    <InputLabel id="collect-by-label">Collect By</InputLabel>
                                    <Select
                                        labelId="collect-by-label"
                                        value={form.CollectBy || ""}
                                        label="Collect By"
                                        onChange={e => dispatch({ type: "UPDATE_FIELD", field: "CollectBy", value: String(e.target.value) })}
                                        sx={{ height: { xs: 36, sm: 40 } }}
                                    >
                                        {usersOptions.map(user => (<MenuItem key={user.UserId} value={String(user.UserId)}>{user.employeeName}</MenuItem>))}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth sx={compactInputStyle}>
                                    <InputLabel id="rcd-by-label">Rcd By</InputLabel>
                                    <Select
                                        labelId="rcd-by-label"
                                        value={form.RcdBy || ""}
                                        label="Rcd By"
                                        onChange={e => dispatch({ type: "UPDATE_FIELD", field: "RcdBy", value: String(e.target.value) })}
                                        sx={{ height: { xs: 36, sm: 40 } }}
                                    >
                                        {usersOptions.map(user => (<MenuItem key={user.UserId} value={String(user.UserId)}>{user.employeeName}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, justifyContent: "space-between", mt: { xs: 2, sm: 3 }, gap: { xs: 1, sm: 1 } }}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={isNewMode ? handleSubmit : handleUpdateKey}
                                    sx={{ height: { xs: 36, sm: 40 }, fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                                >
                                    {isNewMode ? "Submit New" : "Submit Update"}
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleClear}
                                    fullWidth
                                    sx={{ height: { xs: 36, sm: 40 }, fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                                >
                                    Clear
                                </Button>
                            </Box>
                            {keyError && <Typography color="error" sx={{ mt: 1, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>{keyError}</Typography>}
                        </Box>

                        <Box sx={{ width: { xs: "100%", sm: "100%", md: 300 }, mt: { xs: 2, sm: 0 } }}>
                            <Paper elevation={3} sx={{ p: { xs: 1, sm: 2 } }}>
                                <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>LAN Version</Typography>
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={form.selectedOptions.includes("99")} onChange={() => dispatch({ type: "TOGGLE_OPTION", option: "99" })} />}
                                    label="LAN Version?"
                                    sx={{ "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "0.875rem" } } }}
                                />
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                                    <FormControlLabel
                                        label="WhatsApp Key"
                                        control={<Checkbox
                                            size="small"
                                            checked={form.isWhatsAppKeyEnabled}
                                            onChange={(e) => {
                                                dispatch({ type: "UPDATE_FIELD", field: "isWhatsAppKeyEnabled", value: e.target.checked });
                                                if (e.target.checked) {
                                                    handleGenerateWhatsAppKey();
                                                } else {
                                                    dispatch({ type: "UPDATE_FIELD", field: "WAKey", value: "" });
                                                }
                                            }}
                                        />}
                                        sx={{ "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "0.875rem" } } }}
                                    />

                                    <FormControlLabel
                                        control={<Checkbox size="small" checked={form.isMobileAppEnabled} onChange={(e) => handleMobileAppToggle(e.target.checked)} />}
                                        label="Mobile App"
                                        sx={{ "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "0.875rem" } } }}
                                    />

                                    {form.isMobileAppEnabled && (
                                        <TextField
                                            size="small"
                                            label="Number of Mobile App Users"
                                            value={form.MobileAppUsers}
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 1, step: 1, pattern: "\\d*" }}
                                            sx={compactInputStyle}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                if (v === "" || (/^\d+$/.test(v) && parseInt(v, 10) >= 1)) {
                                                    dispatch({ type: "UPDATE_FIELD", field: "MobileAppUsers", value: v });
                                                }
                                            }}
                                        />
                                    )}
                                </Box>

                                <Typography variant="subtitle1" gutterBottom sx={{ mt: { xs: 1, sm: 2 }, fontSize: { xs: "0.9rem", sm: "1rem" } }}>Select Features:</Typography>
                                <FormGroup
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: { xs: "1fr", sm: "1fr" },
                                        rowGap: { xs: 0.3, sm: 0.5 },
                                        maxHeight: { xs: 200, sm: 300 },
                                        overflowY: "auto",
                                        "& .MuiFormControlLabel-root": { alignItems: "center", margin: 0, "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "0.875rem" } } },
                                        "& .MuiCheckbox-root": { p: { xs: 0.3, sm: 0.5 } },
                                    }}
                                >
                                    {checkboxOptions.map((opt) => (
                                        <FormControlLabel
                                            key={opt.Id}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={form.selectedOptions.includes(opt.Id)}
                                                    onChange={() => dispatch({ type: "TOGGLE_OPTION", option: opt.Id })}
                                                />
                                            }
                                            label={opt.Label}
                                        />
                                    ))}
                                </FormGroup>
                            </Paper>
                        </Box>
                    </Box>
                </Box>
            </LocalizationProvider>
        </Container>
    );
}